import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import FormulaireSelectionProjet from '../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import Bouton from '../../../UI/Bouton/Bouton';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../ressources/glossaires/glossaire_pattern';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../../services/actions';
import { AiOutlineCheck } from 'react-icons/ai';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireAlarmeXY.module.scss';

const FormulaireAlarmeXY = (props) => {
  const dispatch = useDispatch();
  const [formulaireAlarmeXY, setFormulaireAlarmeXY] = useState({
    template_id: null,
    Xsensor_id: null,
    Ysensor_id: null,
    Xcomponent_id: null,
    Ycomponent_id: null,
  });

  useEffect(() => {
    if (props.preconfigurerAlarmeXY) {
      setFormulaireAlarmeXY({
        ...props.preconfigurerAlarmeXY,
      });
    }
  }, [props.preconfigurerAlarmeXY]);

  const gererEnvoi = () => {
    if (props.preconfigurerAlarmeXY === undefined) {
      dispatch(actions.reqCreerAlarmesXY(formulaireAlarmeXY));
    } else {
      formulaireAlarmeXY['alarm_xy_id'] =
        props.preconfigurerAlarmeXY.alarm_xy_id;
      dispatch(actions.reqModifierAlarmesXY(formulaireAlarmeXY));
    }
  };

  const gererEtatDeCibleName = (event) =>
    setFormulaireAlarmeXY({
      ...formulaireAlarmeXY,
      [event.target.name]: event.target.value,
    });

  const gererProjetId = (projetId) => {
    setFormulaireAlarmeXY({
      ...formulaireAlarmeXY,
      project_id: projetId,
    });
  };
  const affichageFormulaire = (style, label_state, label_name, pattern) => {
    switch (pattern) {
      case glossaire_pattern.array:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[s.form_control].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={
                props.preconfigurerAlarmeXY !== undefined
                  ? JSON.stringify(formulaireAlarmeXY[label_state])
                  : null
              }
              disabled={props.affichageProfil === true}
              onChange={(event) => gererEtatDeCibleName(event)}
            />
          </div>
        );
      default:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[s.form_control].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={
                props.preconfigurerAlarmeXY !== undefined
                  ? formulaireAlarmeXY[label_state]
                  : null
              }
              disabled={props.affichageProfil === true}
              onChange={(event) => gererEtatDeCibleName(event)}
            />
          </div>
        );
    }
  };

  return (
    <>
      <div className={[s.row].join(' ')}>
        <div className={styles.ConteneurInfo}>
          <div className={[s.container, s.text_left].join(' ')}>
            <form onSubmit={(event) => event.preventDefault()}>
              <div className={s.form_group}>
                <div className={[s.form_row, s.align_items_center].join(' ')}>
                  {/**DEBUT project_id**/}
                  <FormulaireSelectionProjet
                    affichageProfil={props.affichageProfil}
                    gererProjetId={gererProjetId}
                    preconfigurerProjetId={formulaireAlarmeXY.project_id}
                  />
                  {/**FIN project_id**/}
                  {/**DEBUT Xsensor_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Xsensor_id',
                    checkMot('xsensor_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Xsensor_id**/}
                  {/**DEBUT Ysensor_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Ysensor_id',
                    checkMot('ysensor_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Ysensor_id**/}
                  {/**DEBUT Xcomponent_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Xcomponent_id',
                    checkMot('xcomponent_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Xcomponent_id**/}
                  {/**DEBUT Ycomponent_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Ycomponent_id',
                    checkMot('ycomponent_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Ycomponent_id**/}
                  {/**DEBUT template_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'template_id',
                    checkMot('template_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN template_id**/}
                </div>
              </div>
              {props.affichageProfil === true ? null : (
                <div className={s.form_group}>
                  <div
                    className={[s.d_flex, s.justify_content_between].join(' ')}
                  >
                    <div>
                      <Bouton
                        type={type_btn.danger}
                        cliquer={(e) => {
                          e.preventDefault();
                          props.annuler();
                        }}
                      >
                        {checkMot('annuler')}
                      </Bouton>
                    </div>
                    <div
                      className={[s.d_flex, s.justify_content_between].join(
                        ' '
                      )}
                    >
                      {props !== undefined &&
                      props.preconfigurerAlarmeXY === undefined ? (
                        <AttenteRequete
                          request_type={requestType.configurer_des_alarmes_xy}
                          str={checkMot('creation_en_cour')}
                        >
                          <Bouton
                            type={type_btn.succes}
                            ajoutClass={styles.Bts}
                            cliquer={() => gererEnvoi()}
                          >
                            <AiOutlineCheck />
                            {checkMot('creer')}
                          </Bouton>
                        </AttenteRequete>
                      ) : (
                        <AttenteRequete
                          request_type={requestType.modifier_des_alarmes_xy}
                          str={checkMot('modification_en_cour')}
                        >
                          <Bouton
                            type={type_btn.succes}
                            cliquer={() => gererEnvoi()}
                          >
                            {checkMot('enregistrer')}
                          </Bouton>
                        </AttenteRequete>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormulaireAlarmeXY;
